import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    paginationShopCustomers: {
        pageNo: 0,
        limit: 10,
        sortBy: "DESC",
        sortField: "created_at",
        keywords: "",
    },
    statusFilterShopCustomers: "all",
    selectedShopCustomerId: null,
};

export const shopCustomersSlice = createSlice({
    name: "shopCustomers",
    initialState,
    reducers: {
        handlePaginationStateShopCustomers: (state, action) => {
            state.paginationShopCustomers = action.payload;
        },
        setStatusFilterShopCustomers: (state, action) => {
            state.statusFilterShopCustomers = action.payload;
            state.paginationShopCustomers.pageNo = 0;
        },
        setSelectedShopCustomerId: (state, action) => {
            state.selectedShopCustomerId = action.payload;
        },
    },
});

export const { handlePaginationStateShopCustomers, setStatusFilterShopCustomers, setSelectedShopCustomerId } =
    shopCustomersSlice.actions;

export default shopCustomersSlice;
